export const blockIconsTravelChildFriendlyNew = (
	<span className='material-symbols-outlined'>child_friendly</span>
);
